

























































import {
  defineComponent,
  PropType,
  ref,
  getCurrentInstance
} from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccTag from "@/components/Atoms/OccTag/index.vue";
import { sendGaEvent } from "@/helpers/ga-helper";

export type Content<Key = string, SubKey = string> = {
  key: Key;
  name: string;
  errorCount?: number;
  unClickable?: boolean;
  subContents: {
    key: SubKey;
    name: string;
    invalid?: boolean;
    disabled?: boolean;
    unClickable?: boolean;
  }[];
};
export type Props = {
  contents: Content[];
};
export default defineComponent({
  components: {
    OccHeading,
    OccTag
  },
  name: "FormTableOfContents",
  props: {
    contents: {
      type: Array as PropType<Props["contents"]>,
      required: true
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  emits: ["clickContent", "clickSubContent"],
  setup(props, { emit }) {
    const selectedContentKey = ref<string | undefined>(props.contents?.[0].key);
    const instance = getCurrentInstance();

    const onClickContent = (contentKey: string, contentName: string) => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `${props.gaEventCategory}_${contentName}`
        });
      }

      selectedContentKey.value = contentKey;
      emit("clickContent", contentKey);
    };

    const onClickSubContent = (
      contentKey: string,
      subContentKey: string,
      contentName: string,
      subContentName: string
    ) => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `${props.gaEventCategory}_${contentName}_${subContentName}`
        });
      }
      emit("clickSubContent", [contentKey, subContentKey]);
    };

    return {
      onClickContent,
      onClickSubContent,
      selectedContentKey
    };
  }
});
